import React from 'react';
import useDocumentStore from '../stores/documentStore';
import './DocumentsList.css'; // Импортируем стили

function DocumentsList({ documents, activeDocumentId, handleDocumentClick, handleDelete, formatDate }) {
  const isUploading = useDocumentStore(state => state.isUploading);

  return (
    <div className="docslist__container">
      <ul className="docslist__list">
        {documents.map((doc) => (
          <li 
            key={doc.id} 
            onClick={() => handleDocumentClick(doc.id)}
            className={`docslist__item ${doc.id === activeDocumentId ? 'active' : ''}`}
          >
            <div className="docslist__info">
              <span className="docslist__name">{doc.filename}</span>
              <span className="docslist__date">{formatDate(doc.created_at)}</span>
            </div>
            <button 
              className="docslist__delete"
              onClick={(e) => handleDelete(doc.id, e)}
              title="Удалить документ"
            >
              <svg viewBox="0 0 24 24">
                <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
              </svg>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DocumentsList; 
